module.exports = __webpack_public_path__ + "files/8dcaba2d5fac4f36df13fe95e9b4f00c.svg";